<template>
  <div>
    <my-upload
      v-if="hasBio"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="150"
      :height="150"
      :params="params"
      :headers="headers"
      langType="fa"
      :langExt="fa"
      :url="constans.url.baseURL + '/bio/update-img-bio'"
    ></my-upload>
    <my-upload
      v-else
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="150"
      :height="150"
      :params="params"
      :headers="headers"
      langType="fa"
      :langExt="fa"
    ></my-upload>
    <div class="clearfix"></div>
    <button
      class="bttn-fill mt-2 bttn bttn-success btn-block font-16"
      @click="toggleShow"
    >آپلود پروفایل</button>
  </div>
</template>


<script>
import myUpload from 'vue-image-crop-upload';
import constans from "~/constans.js";
export default {
  props: ['hasBio'],
  components: {
    'my-upload': myUpload
  },
  data() {
    return {
      constans: constans,
      show: false,
      params: {
        name: 'img'
      },
      // headers: {
      //   Authorization: 'this.user.token'
      // },
      // imgSrc: '',// the datebase64 url of created image,
      fa: {
        hint: 'کلیک کنید و یا عکس خود را درگ کنید',
        loading: 'در حال آپلود ...',
        noSupported: 'مرورگر خود را به روز کنید',
        success: 'با موفقیت آپلود شد',
        fail: 'آپلود کنسل شد',
        preview: 'نمایش',
        btn: {
          off: 'انصراف',
          close: 'بستن',
          back: 'بازگشت',
          save: 'ذخیره'
        },
        error: {
          onlyImg: 'فقط عکس',
          outOfSize: 'حجم عکس نباید بیشتر از باشد: ',
          lowestPx: 'Image\'s size is too low. Expected at least: '
        }
      }

    }
  },
  computed: {
    headers() {
      return { Authorization: this.user ? this.user.token : '' }
    },
    bio() {
      return this.$store.state.dashboardProfile.bio;
    },
  },

  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
* crop success
*
* [param] imgSrc
* [param] field
*/
    /**
     * Convert a base64 string in a Blob according to the data and contentType.
     * 
     * @param b64Data {String} Pure base64 string without contentType
     * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
     * @param sliceSize {Int} SliceSize to process the byteCharacters
     * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
     * @return Blob
     */
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    // ------WebKitFormBoundaryIAV8FhOJByI4NdIl
    // Content-Disposition: form-data; name="img"; filename="Bank-Melli.png"
    // Content-Type: image/png


    cropSuccess(imgSrc, field) {
      var block = imgSrc.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob = this.b64toBlob(realData, contentType);
      // blob.filename = "imageFilename.png"
      if (!this.hasBio) {
        // this.bio.img = imgSrc;
        this.$store.commit('dashboardProfile/SET_DATA_CHILD', { id: 'bio', child: 'img', data: blob })
        this.$store.commit('dashboardProfile/SET_DATA_CHILD', { id: 'bio', child: 'imgSrc', data: imgSrc })
      }

    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      this.$store.dispatch("auth/upsertUser", { img: jsonData.img });
      this.$store.commit('dashboardProfile/SET_DATA_CHILD', { id: 'bio', child: 'img', data: jsonData.img })
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log('-------- upload fail --------');
      // console.log('field: ' + field);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard-component/upload-avatar/index.vue